<template>
  <div class="Capsule">
    <img class="Capsule__image" :src="image" />
    <h3 class="Capsule__name">{{ name }}</h3>
    <p class="Capsule__volume">{{ volume }} ml</p>
  </div>
</template>
<script>
export default {
  name: 'Capsule',
  props: {
    image: String,
    name: String,
    volume: Number
  }
}
</script>

<style lang="scss">
.Capsule {
  padding: 24px 52px 32px;
  min-width: 367px;
  height: 449px;
  background: #F3F3F6;
  border-radius: 24px;
  margin: 10px;
  &__image {
    // position: relative;
    width: 260px;
    height: auto;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%,-50%);
  }
  &__name {
    font-weight: 600;
    font-size: 24px;
    line-height: 110%;
    text-align: center;
    margin: 21px 0px;
  }
  &__volume {
    color: black;
    font-weight: 600;
     font-size: 32px;
    line-height: 110%;
    text-align: center;
     margin: 21px 0;
  }
}
</style>
